import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { DeclarationOethDto } from "../../../dto/GenApi.iNotPaie.Dto/DeclarationOethDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

interface rapportObject {
    declaration: DeclarationOethDto,
    readOnly: boolean
}

@Component
export default class ModalSaisieOeth extends Vue {
    public declarationOETH: DeclarationOethDto = {
        Id: 0,
        Annee: 0,
        Etat: 0,
        AnneeDsnMetadata: 0,
        BoethExterneMoinsDeCinquanteAns: 0,
        MoisDsnMetadata: 0,
        AccordAgree: false,
        AccueilBoethSurQuatreAns: false,
        DepenseAccompagnementBoeth: 0,
        DepenseCompensationHandicap: 0,
        DepenseDiagnosticEtTravauxBoeth: 0,
        DepensePartenariatAssociation: 0,
        BoethExternePlusDeCinquanteAns: 0,
        DepenseParticipationEvenement: 0,
        DepenseProfessionnalisation: 0,
        DerniereAnneeEffectifSup20Salarie: "",
        BoethInterneMoinsDeCinquanteAns: 0,
        BoethInternePlusDeCinquanteAns: 0,
        MontantContributionAnneePrecedente: 0,
        MontantContributionReelleDue: 0,
        DepenseSousTraitance: 0,
        EffectifEcap: 0,
        EffectifTotal: 0,
        IdSociete: 0,
        RecoursSousTraitanceSurQuatreAns: false,
        IdDsnMetadataFk: 0
    };

    public readOnly = false;

    private listError: string[] = [];

    public errorInputEffectifTotal = false;
    public errorInputEffectif = false;
    public errorRadioAccordAgree = false;
    public errorRadioAccueilBoeth = false;
    public errorRadioRecoursSousTraitance = false;
    public errorNumber = false;

    public init(item: DeclarationOethDto, readOnly: boolean): void {
        this.setData(item, readOnly);
    }

    private setData(item: DeclarationOethDto, readOnly: boolean): void {
        this.declarationOETH = { ...item };
        this.readOnly = readOnly;

        this.listError = [];
        this.errorInputEffectifTotal = false;
        this.errorInputEffectif = false;
        this.errorRadioAccordAgree = false;
        this.errorRadioAccueilBoeth = false;
        this.errorRadioRecoursSousTraitance = false;

        this.$forceUpdate();
    }

    public save(): void {
        if (this.declarationOETH.Id == 0) {
            ServicesFactoryInstance.DeclarationOethService.CreeDeclarationOeth(this.declarationOETH, () => {
                NotificationServiceInstance.SendSuccess("La saisie a bien été sauvegardé");
                this.close();
            });
        } else {
            if (this.declarationOETH.EffectifTotal < 20) {
                ServicesFactoryInstance.DeclarationOethService.ModifieDeclarationOeth(this.declarationOETH, (data) => {
                    this.declarationOETH = data;

                    ServicesFactoryInstance.DeclarationOethService.PrepareDeclarationsOeth(this.declarationOETH.Id, () => {
                        NotificationServiceInstance.SendSuccess("La saisie a bien été sauvegardé");
                        this.close();
                    });
                });
            } else {
                ServicesFactoryInstance.DeclarationOethService.ModifieDeclarationOeth(this.declarationOETH, () => {
                    NotificationServiceInstance.SendSuccess("La saisie a bien été sauvegardé");
                    this.close();
                });
            }
        }
    }

    public next(readOnly: boolean): void {
        this.listError = [];

        // Les déclarations avant 2026 n'avaient pas le champs DerniereAnneeEffectifSup20Salarie
        if (!readOnly && !this.declarationOETH.DerniereAnneeEffectifSup20Salarie) {
            this.listError.push("La dernière année où l'entreprise a atteint un effectif d'au moins 20 salariés doit être sélectionnée.");
        }

        // Error Input Effectif Total
        this.errorInputEffectifTotal = (this.declarationOETH.EffectifTotal < 20);

        if (this.errorInputEffectifTotal) {
            this.listError.push("L'effectif total doit être supérieur ou égal à 20 pour continuer !");
        }

        // Error Radio Accord Agree
        this.errorRadioAccordAgree = (this.declarationOETH.AccordAgree == null);

        if (this.errorRadioAccordAgree) {
            this.listError.push("La sélection d'un accord agréé doit être renseignée !");
        }

        // Error Radio Accueil Boeth
        this.errorRadioAccueilBoeth = (this.declarationOETH.AccueilBoethSurQuatreAns == null);

        if (this.errorRadioAccueilBoeth) {
            this.listError.push("La sélection d'accueil Boeth doit être renseignée !");
        }

        // Error Radio Recours sous-traitance
        this.errorRadioRecoursSousTraitance = (this.declarationOETH.RecoursSousTraitanceSurQuatreAns == null);

        if (this.errorRadioRecoursSousTraitance) {
            this.listError.push("La sélection d'un recours sous-traitance doit être renseignée !");
        }

        // ---------------------------------------------

        if (this.listError.length > 0) {
            NotificationServiceInstance.SendFailedList(this.listError);
        } else {
            const declaration: rapportObject = {
                declaration: this.declarationOETH,
                readOnly: readOnly
            };

            if (readOnly) {
                this.close();
                this.$emit("openRapportOETH", declaration);
            } else {
                if (this.declarationOETH.Id == 0) {
                    ServicesFactoryInstance.DeclarationOethService.CreeDeclarationOeth(this.declarationOETH, (data) => {
                        this.declarationOETH.Id = data.Id;
                        this.close();
                        this.$emit("openRapportOETH", declaration);
                    });
                } else {
                    ServicesFactoryInstance.DeclarationOethService.ModifieDeclarationOeth(this.declarationOETH, () => {
                        this.close();
                        this.$emit("openRapportOETH", declaration);
                    });
                }
            }
        }
    }

    public onDerniereAnneeEffectifSup20SalarieChange(): void {
        if (this.isAccueilBoethSurQuatreAnsDisabled) {
            this.declarationOETH.AccueilBoethSurQuatreAns = false;
            this.errorRadioAccueilBoeth = false;
        }
    }

    public get isAccueilBoethSurQuatreAnsDisabled(): boolean {
        const annee = Number(this.declarationOETH.DerniereAnneeEffectifSup20Salarie);

        return !isNaN(annee) && annee >= 2020;
    }

    public get listAnnees(): string[] {
        const currentYear = new Date().getFullYear();
        const minYear = 2018;
        const years: string[] = [];
        for (let y = currentYear; y >= minYear; y--) {
            years.push(String(y));
        }
        years.push("Années antérieures");
        return years;
    }

    public close(): void {
        this.$emit("refresh");
        $("#modalSaisieOeth").modal("hide");
    }
}



// WEBPACK FOOTER //
// ./src/components/dsn/modalSaisieOeth/modalSaisieOeth.ts